import { useCallback, useEffect, useState } from "react";
import ArticleCard, {
  NewsCardProps,
} from "../../components/common/ArticleCards";
import PageHeader, { dateRangeState, dateTypeState } from "../../components/common/pageHeader/PageHeader";
import useArticles from "../../hooks/useArticleHook";
import { Spin } from "antd";
import { DateRangeObj } from "../../utils/helperFunctions/useDateFilter.js";
import NoDataComponent from "../../components/common/NoDataComponent";
import { useRecoilState } from "recoil";

export default function PublishedNewsMedia() {
  const mediaTypeInitial: string = localStorage.getItem("mediaType") || "digital";
  const [dropdownValue, setDropdownValue] = useState(mediaTypeInitial);
  const [newsArticleList, setNewsArticleList] = useState([]);
  const [digitalFilter, setDigitalFilter] = useState<DateRangeObj | undefined>(
    undefined
  );
  const { articles, loading } = useArticles({ dropdownValue, digitalFilter });
  const [dateRange] = useRecoilState(dateRangeState);
  const [dateType] = useRecoilState(dateTypeState);

  const handleDateRangeChange = (dateRangeObj: DateRangeObj) => {
    setDigitalFilter(dateRangeObj);
  };

  useEffect(() => {
    if (!articles) return;
    setNewsArticleList(articles);
  }, [articles]);

  const fetchDigitalData = useCallback(async () => {
    const crawlerType = mediaTypeInitial;
    
    if (dateRange && dateRange[0] && dateRange[1]) {
      const startDate = dateRange[0].toISOString();
      const endDate = dateRange[1].toISOString();
      
      setDigitalFilter({
        startDate,
        endDate,
        crawlerType,
        dateType
      });
    }
  }, [setDigitalFilter, dateRange, dateType, mediaTypeInitial]);
  
  useEffect(() => {
    fetchDigitalData();
  }, [fetchDigitalData]);

  return (
    <>
      {/* Heading section */}
      <PageHeader
        heading="Published News Media"
        showDropDown={true}
        setDropdownValue={setDropdownValue}
        onDateRangeChange={handleDateRangeChange}
      />

      {/* card grid */}
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <Spin size="large" />
        </div>
      ) : newsArticleList?.length ? (
        <div className="grid grid-cols-1 gap-y-4 gap-x-2 md:grid-cols-3 sm:grid-cols-2 justify-items-center">
          {newsArticleList?.map((newsData: any) => (
            <ArticleCard
              publisher={newsData?.sourceName}
              title={newsData?.title}
              img={newsData?.image_url}
              date={newsData?.pubDate}
              sentiment={newsData?.sentiment}
              traffic={newsData?.traffic}
              description={newsData?.description}
              sourceIcon={newsData?.source_icon || null}
              ave={newsData?.ave}
              keywords={newsData?.keywords}
              country={newsData?.country}
              language={newsData?.language}
              mediaType={dropdownValue}
              length={newsData?.length}
              link={newsData?.link}
            />
          ))}
        </div>
      ) : (
        <div className="flex justify-center items-center h-[500px]">
          <NoDataComponent/>
        </div>
      )}
    </>
  );
}
